<template>
    <div>
	    <myheader ref="header"></myheader>
        <div class="main">
            <div class="navmenu">
                <el-menu
                    :key="menuKey"
                    :default-active="menuActivePath"
                    :default-openeds="defaultOpeneds"
                    class="el-menu-vertical-demo"
                    @select="onMenuSelect"
                    :collapse="collapse"
                >
                    <el-submenu :index="submenuIndex">
                        <template slot="title">
                            <i class="el-icon-shopping-bag-1"></i>
                            <span>{{ sidebarTitle }}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item
                                v-for="item in sidebarMenuItems"
                                :key="item.index"
                                :index="item.index"
                            >
                                <i :class="item.icon"></i>
                                <span slot="title">
                                    {{ item.title }}
                                    <em v-if="menuBadge(item)" class="menu-badge">{{ menuBadge(item) }}</em>
                                </span>
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>
            </div>
            <div class="box">
				<div class="box-view">
					<router-view :key="rkey"/>
				</div>
            </div>
        </div>
    </div>
</template>

<script>
    import { MINI_COMMENT_API, formatMiniGoodsBadge } from '@/constants/retailPlatform'

    const PDD_MENU_ITEMS = [
        { index: '/StoreConfig/basicConfig', icon: 'el-icon-user', title: '拼多多账户' },
        { index: '/StoreConfig/pddGoods', icon: 'el-icon-goods', title: '拼多多商品' },
        { index: '/StoreConfig/pdd/order', icon: 'el-icon-s-order', title: '订单列表' },
        { index: '/StoreConfig/pdd/service', icon: 'el-icon-s-claim', title: '售后列表' },
        { index: '/StoreConfig/pdd/launch', icon: 'el-icon-upload2', title: '一键上架' },
        { index: '/StoreConfig/pdd/log', icon: 'el-icon-document', title: '上架记录' },
    ]

    const MINIPROGRAM_MENU_ITEMS = [
        { index: '/StoreConfig/miniprogram/account', icon: 'el-icon-user', title: '小程序账户' },
        { index: '/StoreConfig/miniprogram/goods', icon: 'el-icon-goods', title: '小程序商品' },
        { index: '/StoreConfig/miniprogram/order', icon: 'el-icon-s-order', title: '订单列表' },
        { index: '/StoreConfig/miniprogram/service', icon: 'el-icon-s-claim', title: '售后列表' },
        { index: '/StoreConfig/miniprogram/dist', icon: 'el-icon-s-cooperation', title: '分销设置' },
        { index: '/StoreConfig/miniprogram/distMembers', icon: 'el-icon-s-custom', title: '分销员' },
        { index: '/StoreConfig/miniprogram/withdraw', icon: 'el-icon-wallet', title: '提现审核' },
        { index: '/StoreConfig/miniprogram/comments', icon: 'el-icon-chat-dot-round', title: '评价管理', badgeKey: 'commentPending' },
    ]

    const TAOBAO_MENU_ITEMS = [
        { index: '/StoreConfig/taobao/account', icon: 'el-icon-user', title: '淘宝账户' },
        { index: '/StoreConfig/taobao/goods', icon: 'el-icon-goods', title: '淘宝商品' },
        { index: '/StoreConfig/taobao/order', icon: 'el-icon-s-order', title: '订单列表' },
        { index: '/StoreConfig/taobao/service', icon: 'el-icon-s-claim', title: '售后列表' },
    ]

    export default {
        name: 'StoreConfig',
        data() {
			return {
				rkey: new Date().toString(),
				collapse: false,
				commentPending: 0,
			}
		},
        computed: {
            isMiniprogram() {
                return this.$route.path.indexOf('/StoreConfig/miniprogram') === 0
            },
            isTaobao() {
                return this.$route.path.indexOf('/StoreConfig/taobao') === 0
            },
            platform() {
                if (this.isTaobao) {
                    return 'taobao'
                }
                if (this.isMiniprogram) {
                    return 'miniprogram'
                }
                return 'pdd'
            },
            sidebarTitle() {
                if (this.platform === 'taobao') {
                    return '淘宝店铺'
                }
                if (this.platform === 'miniprogram') {
                    return '小程序店铺'
                }
                return '拼多多店铺'
            },
            sidebarMenuItems() {
                if (this.platform === 'taobao') {
                    return TAOBAO_MENU_ITEMS
                }
                if (this.platform === 'miniprogram') {
                    return MINIPROGRAM_MENU_ITEMS
                }
                return PDD_MENU_ITEMS
            },
            submenuIndex() {
                if (this.platform === 'taobao') {
                    return '/StoreConfig/taobao'
                }
                if (this.platform === 'miniprogram') {
                    return '/StoreConfig/miniprogram'
                }
                return '/StoreConfig'
            },
            menuKey() {
                return this.platform
            },
            menuActivePath() {
                const path = this.$route.path
                if (path.indexOf('/StoreConfig/batchDetailed') === 0 || path === '/StoreConfig/batchConfig') {
                    return '/StoreConfig/batchConfig'
                }
                if (path === '/StoreConfig/pddGoods' || path.indexOf('/StoreConfig/pddGoods/') === 0) {
                    return '/StoreConfig/pddGoods'
                }
                if (path.indexOf('/StoreConfig/miniprogram/goods') === 0) {
                    return '/StoreConfig/miniprogram/goods'
                }
                if (path === '/StoreConfig/taobao/goods' || path.indexOf('/StoreConfig/taobao/goods/') === 0) {
                    return '/StoreConfig/taobao/goods'
                }
                if (path.indexOf('/StoreConfig/taobao/tabsConfig') === 0
                    || path.indexOf('/StoreConfig/taobao/detailed') === 0) {
                    return '/StoreConfig/taobao/account'
                }
                if (path.indexOf('/StoreConfig/miniprogram/tabsConfig') === 0
                    || path.indexOf('/StoreConfig/miniprogram/detailed') === 0) {
                    return '/StoreConfig/miniprogram/account'
                }
                if (path.indexOf('/StoreConfig/tabsConfig') === 0
                    || path.indexOf('/StoreConfig/detailed') === 0) {
                    return '/StoreConfig/basicConfig'
                }
                return path
            },
            defaultOpeneds() {
                return [this.submenuIndex]
            },
        },
        watch: {
            platform: {
                immediate: true,
                handler(val) {
                    sessionStorage.setItem('storeConfigPlatform', val)
                    const titleMap = {
                        taobao: '直达运动-淘宝',
                        miniprogram: '直达运动-小程序',
                        pdd: '直达运动-拼多多',
                    }
                    document.title = titleMap[val] || '直达运动-拼多多'
                    if (val === 'miniprogram') {
                        this.refreshCommentPending()
                    } else {
                        this.commentPending = 0
                    }
                },
            },
        },
        mounted() {
            this.$root.$on('mini-comment-pending', this.onCommentPending)
            this.refreshCommentPending()
        },
        beforeDestroy() {
            this.$root.$off('mini-comment-pending', this.onCommentPending)
        },
        methods: {
            menuBadge(item) {
                if (!item || !item.badgeKey) {
                    return ''
                }
                if (item.badgeKey === 'commentPending') {
                    return formatMiniGoodsBadge(this.commentPending)
                }
                return ''
            },
            onCommentPending(count) {
                this.commentPending = Number(count) || 0
            },
            refreshCommentPending() {
                if (this.platform !== 'miniprogram') {
                    return
                }
                this.$axios.post(MINI_COMMENT_API.pendingCount, {}).then((res) => {
                    if (!res.data || res.data.code != 0) {
                        return
                    }
                    const pending = Number((res.data.data || {}).pending) || 0
                    this.commentPending = pending
                }).catch(() => {})
            },
            onMenuSelect(index) {
                if (index && index.indexOf('/') === 0) {
                    this.$router.push(index).catch(function() {})
                }
                this.rkey = new Date().toString()
            },
            menuSelect() {
				this.rkey = new Date().toString()
			},
        },
    }

</script>

<style scoped lang="less">
    .main {
		width: 100%;
		min-width: 1200px;
		height: calc(100vh - 41px);
		display: flex;
	}
    .navmenu {
		background-color: #fff;
		position: relative;
		.el-menu {
			height: 100%;
			overflow-y: auto;
			overflow-x: hidden;
		}
		
		
		/deep/ .el-menu-vertical-demo:not(.el-menu--collapse) {
			width: 170px;
			min-width: 170px;
		}

		/deep/ .el-menu-item [class^="el-icon-"],
		/deep/ .el-submenu__title [class^="el-icon-"] {
			margin-right: 6px;
			width: 16px;
			font-size: 16px;
			text-align: center;
			vertical-align: middle;
		}

		.menu-badge {
			display: inline-block;
			min-width: 18px;
			height: 18px;
			margin-left: 6px;
			padding: 0 5px;
			border-radius: 9px;
			background: #f56c6c;
			color: #fff;
			font-style: normal;
			font-size: 12px;
			line-height: 18px;
			text-align: center;
			vertical-align: middle;
		}
		
		.cksq {
			position: absolute;
			width: 21px;
			height: 60px;
			box-sizing: border-box;
			background-color: #fff;
			top: 50%;
			margin-top: -30px;
			right: -20px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 24px;
			color: #909399;
			border: 1px solid #EBEEF5;
			border-left: none;
			cursor: pointer;
		}
	}
    .box {
		width: 100%;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;
		overflow: hidden;

		.box-view {
			height: 100%;
			min-height: 0;
		}
		.container {
			width: 100%;
			height: 100%;
			background-color: #fff;
			box-sizing: border-box;
			padding: 10px 10px 0;
			overflow: auto;
		}
		
		.bg {
			background-color: #f4f4f4;
			padding: 0px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/storeConfig.vue